import React from 'react';

const Error = () => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <h1>404 Error</h1>
      <p>Page not found</p>
    </div>
  );
};

export default Error;
